import styled from "styled-components";

export const AccountTransferForm = styled.div`
  margin: 3rem 1.5rem 1.5rem 1.5rem;
`;

export const Header = styled.h5`
  text-align: center;
`;

export const TopText = styled.div`
  font-size: 0.9rem;
`;

export const CenteredText = styled.p`
  text-align: center;
`;

export const CenteredField = styled.div`
  text-align: center;
`;
